import React, { useEffect } from "react";
import UploadFileList from "../UploadFileList";
// import { useSelector } from "react-redux";

const ProductMedia = (props) => {
  //   const { fileImages } = useSelector((x) => x.fileManager);
  const { productItem } = props;
  return (
    <>
      <div>
        <h6 className="font-semibold m-0 mb-4">Thêm hình ảnh sản phẩm</h6>
      </div>
      <UploadFileList productItem={productItem} />
    </>
  );
};

export default ProductMedia;
